const geoLocationActionTypes = {
  FETCH_GEO_LOCATION_DATA_PROGRESS: 'geoLocation/fetch_data_progress',
  FETCH_GEO_LOCATION_DATA_SUCCESS: 'geoLocation/fetch_data_success',
  FETCH_GEO_LOCATION_DATA_NOT_FOUND: 'geoLocation/fetch_data_not_found',
  FETCH_GEO_LOCATION_DATA_FAILED: 'geoLocation/fetch_data_failed',
};

export default geoLocationActionTypes;
